/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Subject, Subscription } from 'rxjs';

export abstract class SettingsService {
  public settings: any = {};

  public obs = new Subject<any>();
  /**
   * Return the setting key for the storage
   */
  abstract getSettingsKey(): string;

  /**
   * Load the settings on the store if the store contain a corresponding key
   */
  abstract load(force?: boolean): void;

  public subscribe(next: (any) => void, error: (any) => void): Subscription {
    return this.obs.subscribe({ next, error });
  }

  /**
   * Create or update a setting identified by name
   */
  abstract addSetting(name: string, value: any);

  /**
   * get the setting identified by name if the setting exist on the storage
   */
  abstract getSetting(name: string);

  abstract getAuthorization(crud: string[]): boolean;

  /**
   * Store settings on the storage
   */
  abstract save(force?: boolean);

  /**
   * Clear setting of the storage
   */
  abstract clear();

  /**
   * reset setting of the storage  setting = {};
   * in server: will remove setting and prepare to launch again settings from server
   * in local: set isLoaded to false;
   */
  abstract reset();
}
